const map = {
	"./DashboardPageBG.png": 11507,
	"./LocationsPageBG.jpeg": 4156,
	"./NetworksPageBG.jpeg": 29495,
	"./PortalDesignPageBG.jpeg": 7984,
	"./PresenceAnalyticsPageBG.png": 22610,
	"./ReviewsDashboardBG.png": 67023,
	"./airship.png": 34825,
	"./aruba.png": 53250,
	"./atreemo.jpg": 33182,
	"./bloomreach.jpeg": 83274,
	"./braze.png": 91497,
	"./brevo.jpg": 12619,
	"./cambium-networks.png": 3415,
	"./cisco.png": 38594,
	"./claude-ai-logo.png": 65296,
	"./como.svg": 40365,
	"./dark_dropdown_arrow.svg": 31703,
	"./dotdigital.svg": 39324,
	"./dotdigtal.png": 79745,
	"./dropdown_arrow.svg": 13838,
	"./extreme.png": 22115,
	"./favicon-light.png": 25640,
	"./google.png": 46702,
	"./guest-menu-hero.jpg": 2374,
	"./hatch_pattern.png": 3642,
	"./hotjar.png": 30495,
	"./hubrise.png": 36245,
	"./hubspot.png": 94582,
	"./klaviyo.jpg": 9522,
	"./leat.jpeg": 13166,
	"./mailchimp.png": 89653,
	"./meraki-go.png": 66775,
	"./meta.png": 78724,
	"./sevenrooms.jpeg": 16451,
	"./tp-link-omada.png": 32893,
	"./tripadvisor.png": 85244,
	"./unifi.png": 99330,
	"./whatsapp.png": 92841,
	"./zapier.png": 17324
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;